import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials, logout } from "../slices/authSlice";
import { encode } from "base-64";
import i18n from "i18next";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState, endpoint, extra }) => {
    headers.set("Accept-Language", i18n.language);
    const token = getState().auth.token;
    if (endpoint !== "login") {
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
    } else {
      headers.set(
        "authorization",
        `Basic ${encode(process.env.REACT_APP_BASIC_AUTH)}`
      );
    }
    return headers;
  },
});

const clearAuthAndReload = (dispatch) => {
  dispatch(logout());
  try {
    const persisted = JSON.parse(localStorage.getItem("persist:root"));
    if (persisted) {
      persisted.auth = JSON.stringify({ token: null, refreshToken: null });
      localStorage.setItem("persist:root", JSON.stringify(persisted));
    }
  } catch (e) {}
  try {
    sessionStorage.setItem("__auth_reload", String(Date.now()));
  } catch (e) {}
  window.location.reload();
};

const recentlyReloaded = () => {
  try {
    const ts = parseInt(sessionStorage.getItem("__auth_reload"), 10);
    return ts && Date.now() - ts < 30000;
  } catch (e) { return false; }
};

let isReloading = false;

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    const isLoginRequest =
      api.endpoint === "login" || args === "/login" || args?.url === "/login";

    if (isLoginRequest) {
      return result;
    }

    let refreshToken = api.getState().auth.refreshToken;

    if (!refreshToken) {
      api.dispatch(logout());
      return { data: undefined };
    }

    let formData = new FormData();
    formData.append("refresh_token", refreshToken);
    formData.append("grant_type", "refresh_token");

    const refreshResult = await baseQuery(
      { url: "/login", method: "POST", body: formData },
      { ...api, endpoint: "login" },
      extraOptions
    );

    if (refreshResult?.data) {
      api.dispatch(setCredentials({ ...refreshResult.data }));
      try { sessionStorage.removeItem("__auth_reload"); } catch (e) {}
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logout());
      if (!isReloading && !recentlyReloaded()) {
        isReloading = true;
        clearAuthAndReload(api.dispatch);
      }
      return { data: undefined };
    }
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({}),
});
